import { ToolPcdCanvasContext } from '../ToolPcdCanvasContext';

const useToolPcdCanvasContext = () => ToolPcdCanvasContext.hook();

export default useToolPcdCanvasContext;
